<template>
  <div class="alert-container" v-if="alertsAll.length">
    <div class="alerts-panel">
      <h1>Alerta!</h1>
      <div class="alert-item" v-for="alerta in alertsAll" :key="alerta.id">
        <p>{{ alerta.alerta }}</p>
      </div>
      <button @click="fecharAlertas()" class="close-button">Fechar</button>
    </div>
  </div>
</template>

<script>
import axios from "../../plugins/axios";
export default {
  props: ["estudante"],
  data() {
    return {
      alertsAll: [],
    };
  },

  async created() {
    await this.getAllAlerts();
  },

  methods: {
    async getAllAlerts() {
      try {
        const response = await axios.get(`/getStudentAlert/${this.estudante.numero_matricula}`);
        this.alertsAll = response.data || [];
      } catch (error) {
        console.error('Erro ao carregar alertas:', error);
      }
    },

    fecharAlertas() {
      this.$emit('fecharComponent', false);
    },
  },
};
</script>

<style scoped>
.alert-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.alerts-panel {
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  width: 80%;
  max-width: 600px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.alerts-panel h1 {
  font-size: 1.5rem;
  margin-bottom: 20px;
}

.alert-item {
  background-color: #f0f0f0;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
  text-align: left;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.close-button {
  background-color: #2b4bdb;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
}

.close-button:hover {
  background-color: #1b244b;
}
</style>
